import { graphql } from "react-relay";

export const CreateJobMutation = graphql`
  mutation CreateJobMutation($input: CreateJobInput!) {
    createJob(input: $input) {
      job {
        id
        name
        inputJson
        schedule
        taskType
        status
      }
    }
  }
`;